module.exports = __webpack_public_path__ + "img/ad-funvjie.8f6e0558.png";